import { FormField, FormFieldType } from '@hclinear/hc-linear-react';
import { t } from '@localization/i18n';
import { requiredStringValidation } from '@/constant';
import { GroupDTO, ImageTypeDTO } from '@/model';
import { mapToSelectOptions } from '@/util';

export const imageModalFormFields = (
  groups: GroupDTO[],
  isTypeEditable: boolean,
): FormField[] => [
  {
    type: FormFieldType.File,
    label: 'common.image',
    name: 'file',
    allowedMimeTypes: ['image/png'],
    validation: requiredStringValidation(),
  },
  {
    type: FormFieldType.Select,
    label: 'common.groups',
    name: 'groupIds',
    options: mapToSelectOptions(groups),
    xs: 12,
    isMultiselect: true,
  },
  {
    type: FormFieldType.Text,
    name: 'name',
    label: 'common.name',
    xs: 12,
    validation: requiredStringValidation(),
  },
  {
    type: FormFieldType.Select,
    label: 'common.type',
    name: 'type',
    disabled: !isTypeEditable,
    options: [
      ImageTypeDTO.IMAGE_DISPLAY_NORMAL,
      ImageTypeDTO.PAGER,
      ImageTypeDTO.GENERAL_BACKGROUND,
      ImageTypeDTO.STATIC_TIMETABLE,
      ImageTypeDTO.DYNAMIC_TIMETABLE_BACKGROUND,
      ImageTypeDTO.ANNOUNCEMENT_IMAGE,
    ]?.map((value) => ({
      value,
      label: t(`enum.${value?.toLowerCase()}`),
    })),
    validation: requiredStringValidation(),
  },
  {
    type: FormFieldType.Text,
    name: 'description',
    label: 'common.description',
    xs: 12,
    isMultiRow: true,
  },
];
